export const CompanyIdInput = ({value}) => {
    return (
        <input 
            type="hidden" 
            name="company_id" 
            value={value} 
        />
    );
};
